import React from 'react';
import config from '../../../../config';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button, Col, Row, FormControl } from 'react-bootstrap';
import classNames from 'classnames';
import sharedUtil from '../../../../sharedUtil';
import PaginationBox from 'shared/PaginationBox';
import { formatImageForBucket, customFormatter } from 'util/Utils';

export const ListingSelectionScreen = (props) => {
  const { screensData } = props;
  const { selectedGBGProduct = {}, GBGProductNotFound } = screensData;
  const GBGProductLabel = `${selectedGBGProduct.Brand} ${selectedGBGProduct.Model}`;

  return (
    <Row data-testid='screen-content'  className="screen-content">
      <div>{selectedGBGProduct._id && props.renderVariationsForSelectedGBGProduct()}</div>
      {selectedGBGProduct._id && (
        <Row className="filter-inputs-box ">
          <Col md={2} sm={2} xs={12} className="  top10 bot10">
            <FormControl
              data-testid='SKU-text-input'
              type="text"
              value={screensData.listingsSearchText || ''}
              onChange={(event) => {
                props.setScreensData(
                  {
                    GBGProductsFetched: false,
                    GBGProductsData: [],
                    listingsSearchText: event.target.value,
                  },
                  () => {
                    (function (props) {
                      /* self-executing method to be able to access props */
                      props.searchProductsDebounce({});
                    })(props);
                  }
                );
              }}
              placeholder="Search by SKU"
            />
          </Col>
        </Row>
      )}
      <Col md={6} xs={6} className={classNames('top10 align-center')}>
        {screensData.listingsFetched && (
          <div>
            <div>
              {screensData.listingsData.length == 0 ? (
                <div className="messageBox font-size-19  ">
                  {'No matching listings found ' + (selectedGBGProduct._id ? `for ${GBGProductLabel}` : '')}
                </div>
              ) : (
                <div className="">
                  <div className="text-bold text-center bot17">{`Select listing for ${GBGProductLabel}`}</div>

                  <BootstrapTable
                    data={screensData.listingsData}
                    hover={true}
                    style={{ maxHeight: 500 }}
                    bordered={false}
                  >
                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={true} hiddenOnInsert>
                      Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      width="60px"
                      editable={false}
                      columnClassName="product-listings-column"
                      dataFormat={customFormatter}
                      formatExtraData={{
                        path: ['getObject'],
                        format: (item) => {
                          return renderListingRow(item, props);
                        },
                      }}
                      dataAlign="center"
                    >
                      Products
                    </TableHeaderColumn>
                  </BootstrapTable>
                  <PaginationBox
                    customTotalBoxClass={'float-none'}
                    currentPage={screensData.listingsPage || 0}
                    perPage={50}
                    total={screensData.listingsTotal || 1}
                    search={(params) => {
                      props.searchProductsDebounce(params);
                    }}
                  ></PaginationBox>
                </div>
              )}
            </div>
            {(selectedGBGProduct._id || GBGProductNotFound) && (
              <div className="top30  set-width align-center">
                <Button
                  disabled={props.pending}
                  data-testid='generate-new-SKU-button'
                  className="btn btn-lg btn-primary custom-btn set-width "
                  onClick={() => {
                    props.generateNewSKUHandler();
                  }}
                >
                  <div>
                    <div>Not Found</div>
                    <div>(Generate New SKU)</div>
                  </div>
                </Button>
              </div>
            )}
          </div>
        )}
      </Col>
    </Row>
  );
};

function renderListingRow(item, props) {
  let SKU = item.SKU || '';
  const match = sharedUtil.matchSKU(SKU, { maxDigitsNumber: 3 });
  let locationInWarehouse = '';

  if (match) {
    SKU = match[1];

    if (match[2]) {
      locationInWarehouse = match[2].replace('-', '');
    }
  }

  const { OriginalImages = [] } = item;
  const serverURL = config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '';

  return (
    <Row onClick={() =>{
      console.log('on click' , item );
      props.selectProductListing(item);
    }} className="product-listing-box pleft10 ptop15 pbot10 pright10" style={{}}>
      <Col xs={12} className="text-left">
        <div className="pull-left right15   ">
          <img
            style={{
              width: 150,
              height: '100%',
            }}
            src={
              OriginalImages[0] && OriginalImages[0].URL
                ? formatImageForBucket(OriginalImages[0].URL)
                : `${serverURL}/theme/assets/no-image-available.png`
            }
          />
        </div>
        <div className="font-size-19">{item.ProductName} </div>

        <div className="font-size-21 text-bold top20">
          <span className="purple">{SKU}</span>
          {locationInWarehouse !== '' ? (
            <span>
              <span> - </span> <span className="orange">{locationInWarehouse}</span>
            </span>
          ) : (
            ''
          )}
        </div>
      </Col>
    </Row>
  );
}
